export function makePhoneUrl(number: string, protocol: 'tel' | 'sms'): string {

	if (!number) return '';
	
	const digits = ((number || '').match(/\d/g) ?? []).join('');
	if (digits.length == 0) return '';

	return `${protocol}:+${digits}`;
}